import { useTranslation } from "react-i18next";
import { redirect } from "../../../../utils/reformat";
import i18n from "../../../../i18n";
import { useWebview } from "../../../../hooks/useWebview/useWebview";
import GenericComponent from "../../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../../assets/img/error-illustration.svg";

const MissingData = () => {
  const { t } = useTranslation();
  const { postMessage } = useWebview();

  return (
    <GenericComponent
      ImageSrc={Image}
      pageTitle={t`screens.errors.missingData.title`}
      pageSubtitle={"screens.errors.missingData.subtitle"}
      buttonLabel={t`screens.common.backHome`}
      transComponent={{
        B: <strong />,
      }}
      onClickCallback={() => {
        postMessage("error");
        redirect(`https://www.corner.ch/${i18n.resolvedLanguage}`);
      }}
    />
  );
};

export default MissingData;
